import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-scora-common-module',
  templateUrl: './scora-common-module.component.html',
  styleUrls: ['./scora-common-module.component.css']
})
export class ScoraCommonModuleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-common-module/scora-common-module.component.ts